module.exports = __webpack_public_path__ + "img/pr-9.a7cf31b0.png";